import React from 'react'
import ExclPointCircleIcon from '../../components/Icons/outline/ExclPointCircleIcon'
import { COLORS } from '../../config'
import { COUNTRIES } from '../../helpers/selectOptions'
import FieldWithEdit from '../../components/FieldItems/FieldWithEdit'
import FieldWithSelectEdit from '../../components/FieldItems/FieldWithSelectEdit'
import ToggleField from '../../components/FieldItems/ToggleField'

function BillingInputForm({
  user,
  formError,
  setBillingInfo,
  billingInfo
}) {

  const [usePersonalInfo, setUsePersonalInfo ] = React.useState(true)
  
  const toggleInfo = () => {
    let toggledState = !usePersonalInfo;
    setUsePersonalInfo(toggledState);
    if (toggledState) setBillingInfo({
        country: user.location.country,
        city: user.location.city,
        address: user.location.address,
        postal_code: user.location.postal_code,
      });
    if (!toggledState) setBillingInfo({
        country: '',
        city: '',
        address: '',
        postal_code: '',
      });
  };

  const countryOptions = [];
  if (!countryOptions.length) COUNTRIES.forEach(country => {
    countryOptions.push({
      value: country,
      label: country
    })
  });

  return (
    <div id='billing' className="w-full rounded bg-white shadow flex flex-col p-10 mt-6">
      <div className='flex justify-between'>
      <h1 className="text-2xl text-secondary ">Billing information</h1>
      {formError.field === 'billing' && 
      <span className="flex text-red-400 text-sm col-span-4">{formError.msg}{<ExclPointCircleIcon className='ml-2' stroke={COLORS.deleteRed}/>}</span>
      }
      </div>
      <div className='w-full mt-4 mb-10'>  
        <ToggleField 
          label='Use existing personal information' 
          onChange={toggleInfo} 
          selected={usePersonalInfo}
        />
      </div>
      <div className='grid grid-cols-1 gap-y-4'>
        <FieldWithSelectEdit 
          label='Country' 
          options={countryOptions} 
          data={billingInfo.country} 
          onChange={(e) => setBillingInfo(prev => ({...prev, country: e.value }))} 
          edit={!usePersonalInfo}
          
        /> 
        <FieldWithEdit 
          label='City' 
          data={billingInfo.city} 
          onChange={(e) => setBillingInfo(prev => ({...prev, city: e.target.value}))} 
          edit={!usePersonalInfo}
        />
        <FieldWithEdit 
          label='Address' 
          data={billingInfo.address} 
          onChange={(e) => setBillingInfo(prev => ({...prev, address: e.target.value}))} 
          edit={!usePersonalInfo}
        />
        <FieldWithEdit 
          label='Postal code' 
          data={billingInfo.postal_code} 
          onChange={(e) => setBillingInfo(prev => ({...prev, postal_code: e.target.value}))} 
          edit={!usePersonalInfo}  
          min='5' 
          max='5'
        />
      </div>
    </div>
  )
}

export default BillingInputForm
